/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_profile_messages_loadingprojects1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로젝트 로딩 중...`)
};

const en_profile_messages_loadingprojects1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading projects...`)
};

const ja_profile_messages_loadingprojects1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトを読み込み中...`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const profile_messages_loadingprojects1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.profile_messages_loadingprojects1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("profile_messages_loadingprojects1", locale)
	if (locale === "ko") return ko_profile_messages_loadingprojects1(inputs)
	if (locale === "en") return en_profile_messages_loadingprojects1(inputs)
	return ja_profile_messages_loadingprojects1(inputs)
};
export { profile_messages_loadingprojects1 as "profile_messages_loadingProjects" }